import { useCallback } from "react";
import { NavigationType, useBlocker } from "react-router";

export function useBlockHistoryNavigation(shouldBlock: boolean): void {
	const shouldBlockNavigation = useCallback(
		(navigation: { historyAction: NavigationType; }): boolean => {
			return shouldBlock
				&& navigation.historyAction === NavigationType.Pop;
		},
		[shouldBlock]
	);

	useBlocker(shouldBlockNavigation);
}
